import React from 'react';

import { learnJSData } from 'data/javascript/learn';

import DescriptionEntry from 'components/shared/description-entry';

const JavaScriptFlow = () => {
  const item = learnJSData?.items.find(
    (item) => item.title === 'JavaScript Flow'
  );

  return <DescriptionEntry entry={item} />;
};

export default JavaScriptFlow;
